import { render, staticRenderFns } from "./OverallData.vue?vue&type=template&id=1ca077bc&scoped=true&"
import script from "./OverallData.vue?vue&type=script&lang=js&"
export * from "./OverallData.vue?vue&type=script&lang=js&"
import style0 from "./OverallData.vue?vue&type=style&index=0&id=1ca077bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca077bc",
  null
  
)

export default component.exports